import { Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { Observable } from 'rxjs';
import { IParkingDetail, IParkingFilterParams, IParkingLocation } from '../models/parking-map';
import { IParkingCategoryModel, IParkingTypeModel } from '@aggregator/core';
import { IPageableResponse, IResponse } from '@aggregator/core';

@Injectable({
  providedIn: 'root',
})
export class ParkingApiService extends BaseService {
  getParkingLocations(
    params: Partial<IParkingFilterParams> | null,
  ): Observable<IResponse<IPageableResponse<IParkingLocation>>> {
    return this.get('parkings/positioning', params);
  }

  getParkingById(id: string): Observable<IResponse<IParkingDetail>> {
    return this.get(`parkings/positioning/${id}`);
  }

  getAllParkingTypes(filter?: unknown): Observable<IResponse<IParkingTypeModel[]>> {
    return this.get<IResponse<IParkingTypeModel[]>>(`parkings/types`, filter);
  }

  getAllParkingCategories(filter?: unknown): Observable<IResponse<IParkingCategoryModel[]>> {
    return this.get<IResponse<IParkingCategoryModel[]>>(`parkings/categories`, filter);
  }
}
